<mat-tab-group class="booking-details" animationDuration="0ms" [formGroup]="form" #tab>

  <!--Extra(s)-->
  <mat-tab label="{{ 'Extras' | translate }}">
    <h2>
      <div class="selected-class-title">
        <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faClipboard"></fa-icon>
        {{ 'AdditionalServices' | translate }}
      </div>
    </h2>
    <div class="ml-3-booking">
      <ng-container
        *ngIf="vehicleReservationCaseDetailsModel&&vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase!=null">
        <ng-container *ngFor="let additionalService of getAdditionalServiceReservationCaseTypeService()">

          <div [ngSwitch]="additionalService.predefinedAdditionalServiceID">


            <!--Start Additional Services-->
            <div class="row " *ngSwitchCase="predefinedAdditionalServiceEnum.AdditionalDrivers">
              <div class="col-md-1 col-2 slider text-right mt-1">
                <div class="custom-control  custom-switch custom-switch-additional">
                  <input type="checkbox" (change)="changeDisable(additionalService)"
                    [formControlName]="formControlPrefix+additionalService.additionalServiceID+'_toggle'"
                    name="additionalDriver" class="custom-control-input" id="customSwitches1">
                  <label class="custom-control-label" for="customSwitches1"></label>
                </div>
              </div>
              <div class="col-md-11 col-10 mb-2 mobile-margin pl-0">
                <div class="d-flex">
                  <div class="detail-title ml-2 mr-3">
                    <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    {{additionalService.serviceName}}
                    <!-- <mat-icon class="mr-1 detailsIcon" svgIcon="steeringWheel"></mat-icon>-->
                    <span class="detail-price ml-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></span>
                    <!-- <div class="description">{{additionalService.description}}  </div>  -->
                  </div>
                  <input type="text" type="number"
                    (keypress)="numberOnly($event)"
                    (change)="checkIFValidQuantity($event.target.value,additionalService)"
                    class="form-control form-control-number ml-auto  services-input" placeholder="1"
                    [formControlName]="formControlPrefix+additionalService.additionalServiceID" [min]="1"
                    aria-label="driverInformation">
                </div>

              </div>
            </div>
            <!--End Additional Services-->
            <!--Start Crossing Borders-->
            <div class="row mb-2" *ngSwitchCase="predefinedAdditionalServiceEnum.CrossingBoarders">
              <div class="col-md-1 col-2 slider text-right mt-1">

                <div class="custom-control custom-switch custom-switch-additional">
                  <input type="checkbox" (change)="changeDisable(additionalService)"
                    [formControlName]="formControlPrefix+additionalService.additionalServiceID+'_toggle'"
                    name="crossingBoarders" class="custom-control-input" id="customSwitches">
                  <label class="custom-control-label" for="customSwitches"></label>
                </div>

              </div>
              <div class="col-md-11 col-10 mb-2 mobile-margin pl-0">
                <div class="d-flex">
                  <div class="detail-title ml-2 d-flex mr-3">
                    <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    {{additionalService.serviceName}}
                  </div>

                  <div *ngIf="showExistBorder">
                    <div class="validation-error">
                      <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Thiscrossingborderswasaddedbefore' |
                      translate }}
                    </div>
                  </div>

                </div>
                <div class="form-group mb-0  mt-1 row ml4"
                  [ngClass]="{'showControls': form.controls[formControlPrefix+ additionalService.additionalServiceID+ formControlTogglePostfix]!=null&&!form.controls[formControlPrefix+ additionalService.additionalServiceID+ formControlTogglePostfix].value}">

                  <div class="col-lg-7  mb-2 col-md-7 col-11 ml2">

                    <mat-form-field appearance="none">
                      <mat-select panelClass="select-booking-detail" placeholder="{{ 'SelectLocation' | translate }}"
                        #crossBorderSelect class="form-control select"
                        [formControlName]="formControlPrefix+additionalService.additionalServiceID"
                        disableOptionCentering>
                        <mat-option *ngFor="let border of crossBorders" [value]="border">
                          {{border.borderPortName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div class=""
                      *ngIf="submitted&&form.get(formControlPrefix+additionalService.additionalServiceID+'_Borders').errors!=null">
                      <div class="validation-error">
                        <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                      </div>
                    </div>


                  </div>
                  <div class="col-md-4 pl-0 col-1">
                    <button class="btnLink btnLinkIcon mt-2"
                      (click)="addCrossingBorderToForm(additionalService,crossBorderSelect.selectedIndex)"
                      [disabled]="form.controls[formControlPrefix+additionalService.additionalServiceID]!=null&&form.controls[formControlPrefix+additionalService.additionalServiceID].disabled">
                      <fa-icon placement="top" ngbPopover="{{ 'AddCrossingBorder' | translate }}" container="body"
                        triggers="mouseenter:mouseleave" [icon]="faPlusCircle"></fa-icon>
                    </button>
                  </div>

                  <div class="col-md-12 pr-sm-0" *ngIf="borders!=null">
                    <div *ngFor="let crossingBorder of borders.controls; let i = index">
                      <div [formGroup]="crossingBorder" class="form-row d-flex">
                        <div class="crossingBorder  ml-3">
                          {{crossingBorder.controls['BorderName'].value}}<button class="btnLink btnLinkDelete"
                            (click)="deleteCrosingBorder(i)">
                            <fa-icon [icon]="faTimesCircle"></fa-icon>
                            <!--formControlName="BorderName"-->
                          </button>
                        </div>
                        <div class="crossingBorderDescription"><span class="ml-2">{{ 'PassPermit' | translate }}</span><span
                            class="ml-2">{{ 'AdditionPermission' | translate }}</span></div>
                        <div class="ml-auto mr-2 mb-2 w-75">

                          <!-- <input type="text" type="number" formControlName="BorderValue"
                              class="form-control form-control-number ml-auto" placeholder="1" aria-label="driverInformation"> -->
                          <input class="form-control  services-input" type="text"
                            value="{{crossingBorder.controls['BorderValue'].value}}" disabled>


                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>
            </div>
            <!--End Crossing Borders-->

            <!--Start Drivers-->
            <div class="row mb-1" *ngSwitchCase="predefinedAdditionalServiceEnum.Drivers">
              <div class="col-md-1 col-2 slider text-right mt-1">

                <div class="custom-control custom-switch custom-switch-additional">
                  <input type="checkbox" (change)="changeDisable(additionalService)"
                    [formControlName]="formControlPrefix+additionalService.additionalServiceID+'_toggle'" name="drivers"
                    class="custom-control-input" id="customSwitches3">
                  <label class="custom-control-label" for="customSwitches3"></label>
                </div>

              </div>
              <div class="col-md-11 col-10 mb-2 mobile-margin pl-0">
                <div class="d-flex">
                  <div class="detail-title ml-2 d-flex mr-3">
                    <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    {{additionalService.serviceName}}
                  </div>
                  <!--src="http://localhost/GCU.CarRental.AdminSite/Helpers/ImageRouteHandler.ashx?referenceId=2986&scopeId=7&typeId=35"-->
                </div>
                <div class="form-group mb-0  mt-1 row ml4"
                  [ngClass]="{'showControls': form.controls[formControlPrefix+ additionalService.additionalServiceID+ formControlTogglePostfix]!=null&&!form.controls[formControlPrefix+ additionalService.additionalServiceID+ formControlTogglePostfix].value}">
                  <div class="col-lg-7 col-md-7 col-12 ml2">

                    <mat-form-field appearance="none">
                      <mat-select panelClass="select-booking-detail" placeholder="{{ 'SelectSkills' | translate }}"
                        multiple #DriverSelect class="form-control select"
                        (selectionChange)="driverSkillChange($event.value)"
                        [formControlName]="formControlPrefix+additionalService.additionalServiceID"
                        disableOptionCentering>
                        <mat-option *ngFor="let skill of driverSkills" [ngValue]="skill" [value]="skill">
                          {{skill.driverSkillName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>



                  </div>
                </div>
              </div>
            </div>
            <!--End Drivers-->
            <!--Start One Way Rental-->
            <div class="row mb-2" *ngSwitchCase="predefinedAdditionalServiceEnum.OneWayRentalService">
              <div class="col-md-1 col-2 slider text-right mt-1">

                <div class="custom-control custom-switch custom-switch-additional">
                  <input type="checkbox" (change)="changeDisable(additionalService)"
                    [formControlName]="formControlPrefix+additionalService.additionalServiceID+'_toggle'"
                    name="oneWayRentalService" class="custom-control-input" id="customSwitches4">
                  <label class="custom-control-label" for="customSwitches4"></label>
                </div>

              </div>



              <div class="col-md-11 col-10 mb-2 mobile-margin pl-0">
                <div class="d-flex">
                  <div class="detail-title ml-2 d-flex mr-3">
                    <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    {{additionalService.serviceName}}
                  </div>
                </div>
                <div class="form-group mb-0  mt-1 row ml4"
                  [ngClass]="{'showControls': form.controls[formControlPrefix+ additionalService.additionalServiceID+ formControlTogglePostfix]!=null&&!form.controls[formControlPrefix+ additionalService.additionalServiceID+ formControlTogglePostfix].value}">
                  <div class="col-lg-7 col-md-7 col-12 ml2">

                    <mat-form-field appearance="none" *ngIf="oneWayRentalFlag&&form.controls[formControlPrefix+additionalService.additionalServiceID]!=null">
                      <mat-select panelClass="select-booking-detail" placeholder="{{ 'SelectLocation' | translate }}"
                        class="form-control select w-290"
                        (selectionChange)="OneWayRentalChanged($event.value,additionalService)"
                        [formControlName]="formControlPrefix+additionalService.additionalServiceID"
                        data-placeholder="Select" [compareWith]="compareOneWayRentalsId" disableOptionCentering>
                        <mat-option *ngFor="let location of oneWayRentalLocations" [value]="location">
                          {{location.agencyReturnLocationName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>



                    <div class=""
                      *ngIf="submitted&&form.get(formControlPrefix+additionalService.additionalServiceID).errors!=null">
                      <div class="validation-error">
                        <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                      </div>
                    </div>

                  </div>
                </div>


              </div>
            </div>
            <!--End One Way Rental-->
            <!--Start Agent Delivery Service-->
            <div class="row mb-2" *ngSwitchCase="predefinedAdditionalServiceEnum.RentalDelivery">
              <div class="col-md-1 col-2 slider text-right mt-1">

                <div class="custom-control custom-switch custom-switch-additional">
                  <input type="checkbox" (change)="changeDisable(additionalService)"
                    [formControlName]="formControlPrefix+additionalService.additionalServiceID+'_toggle'"
                    name="rentalDelivery" class="custom-control-input" id="customSwitches5">
                  <label class="custom-control-label" for="customSwitches5"></label>
                </div>

              </div>



              <div class="col-md-11 col-10  mobile-margin pl-0"
                [formGroupName]="formControlPrefix+additionalService.additionalServiceID">
                <div class="d-flex ">
                  <div class="detail-title ml-2 d-flex mr-3"><img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    {{additionalService.serviceName}}</div>
                  <div class=""
                    *ngIf="submitted&&form.get(formControlPrefix+additionalService.additionalServiceID+'_RentalDeliveryFirstValidation').errors!=null">
                    <div class="validation-error">
                      <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Pleaseselectatleastone' | translate }}
                    </div>
                  </div>
                </div>
                <!--Not Complete yet-->
                <!--IF checked and no Location checked (Pick-Return)-->

                <div class="mt-3"
                  [ngClass]="{'showControls': form.controls[formControlPrefix+ additionalService.additionalServiceID+ formControlTogglePostfix]!=null&&!form.controls[formControlPrefix+ additionalService.additionalServiceID+ formControlTogglePostfix].value}">
                  <div class="d-flex flex-wrap mb-2 ml-4 align-items-center service-view">
                    <mat-checkbox disableRipple class="mr-3"
                      (change)="rentalDeliveryCheckBoxToggle('PickUpToggle','PickUpLocation','PickUpLocationName',additionalService)"
                      formControlName="PickUpToggle">{{ 'Pickup' | translate }}</mat-checkbox>
                    <div class="detail-price l-25 mr-3">{{additionalService.unitPrice}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></div>
                    <div>
                      <div class="d-flex">
                        <input type="text" formControlName="PickUpLocationName" class="form-control w-228" readonly
                          placeholder="{{ 'LocationinCity' | translate }}" aria-label="Location in City"
                          aria-describedby="basic-addon1"
                          (blur)="openMapDialog(1,'PickUpLocationName','PickUpLocation',additionalService.additionalServiceID)">
                        <button class="btnLink btnLinkIcon btn-map" [disabled]="pickupLocationFlag"
                          (click)="openMapDialog(1,'PickUpLocationName','PickUpLocation',additionalService.additionalServiceID)">
                          <fa-icon placement="top" ngbPopover="{{ 'AddLocation' | translate }}" container="body"
                            triggers="mouseenter:mouseleave" class="fa-s" [icon]="faMapMarkerAlt"></fa-icon>
                        </button>
                      </div>
                      <div class="w-100"
                        *ngIf="submitted&&form.get(formControlPrefix+additionalService.additionalServiceID+'.PickUpLocationName').errors!=null">
                        <div class="validation-error">
                          <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                        </div>
                      </div>

                    </div>

                  </div>

                  <div class="d-flex flex-wrap mb-3 ml-4 align-items-center service-view">
                    <mat-checkbox disableRipple class="mr-3 return-ar" formControlName="ReturnToggle"
                      (change)="rentalDeliveryCheckBoxToggle('ReturnToggle','ReturnLocation','ReturnLocationName',additionalService)">
                      {{ 'Return' | translate }}
                    </mat-checkbox>
                    <div class="detail-price l-25 mr-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></div>
                    <div>
                      <div class=" d-flex">
                        <input type="text" readonly formControlName="ReturnLocationName" class="form-control w-228"
                          placeholder="{{ 'LocationinCity' | translate }}" aria-label="Location in City"
                          (blur)="openMapDialog(2,'ReturnLocationName','ReturnLocation',additionalService.additionalServiceID)"
                          aria-describedby="basic-addon1">
                        <button class="btnLink btnLinkIcon btn-map" [disabled]="returnLocationFlag"
                          (click)="openMapDialog(2,'ReturnLocationName','ReturnLocation',additionalService.additionalServiceID)">
                          <fa-icon placement="top" ngbPopover="{{ 'AddLocation' | translate }}" container="body"
                            triggers="mouseenter:mouseleave" class="fa-s" [icon]="faMapMarkerAlt"></fa-icon>
                        </button>
                      </div>
                      <div class="w-100"
                        *ngIf="submitted&&form.get(formControlPrefix+additionalService.additionalServiceID+'.ReturnLocationName').errors!=null">
                        <div class="validation-error">
                          <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div *ngSwitchDefault>

              <!--IsAddOn-->
              <div class="row" *ngIf="additionalService.isPhysicalAddon">
                <div class="col-md-1 col-2 slider text-right mt-1">
                  <div class="custom-control custom-switch custom-switch-additional">
                    <input type="checkbox" (change)="changeDisable(additionalService)"
                      [formControlName]="formControlPrefix+additionalService.additionalServiceID+'_toggle'"
                      class="custom-control-input" [id]="additionalService.additionalServiceID">
                    <label class="custom-control-label" [for]="additionalService.additionalServiceID"></label>
                  </div>
                </div>
                <div class="col-md-11 col-10 mb-2 mobile-margin pl-0">
                  <div class="d-flex">
                    <div class="detail-title ml-2 mr-3">
                      <img class="icon-extra"
                        [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                      <!-- <mat-icon class="mr-1 detailsIcon" svgIcon="childSeats"></mat-icon> -->
                      {{additionalService.serviceName}}
                      <span class="detail-price ml-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></span>
                      <!-- <div class="description">{{additionalService.description}}  </div>  -->
                    </div>
                    <input type="number"  [max]="additionalService.maxQuantityAllowed"
                      (keypress)="numberOnly($event)"
                      (change)="checkIFValidQuantity($event.target.value,additionalService)"
                      [formControlName]="formControlPrefix+additionalService.additionalServiceID"
                      class="form-control form-control-number ml-auto services-input" placeholder="1"
                      aria-label="driverInformation" [min]="1">
                  </div>

                </div>
              </div>
              <!-- Else-->
              <div class="row" *ngIf="!additionalService.isPhysicalAddon">
                <div class="col-md-1 col-2 slider text-right mt-1">

                  <div class="custom-control custom-switch custom-switch-additional">
                    <input type="checkbox" (change)="changeDisable(additionalService)"
                      [formControlName]="formControlPrefix+additionalService.additionalServiceID+'_toggle'"
                      class="custom-control-input" [id]="additionalService.additionalServiceID">
                    <label class="custom-control-label" [for]="additionalService.additionalServiceID"></label>
                  </div>

                </div>
                <div class="col-md-11 col-10 mb-2 mobile-margin pl-0">
                  <div class="d-flex">
                    <div class="detail-title ml-2 mr-3">
                      <img class="icon-extra"
                        [src]="attachmentService.getImageLink(additionalService.additionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                      <!-- <mat-icon class="mr-1 detailsIcon" svgIcon="childSeats"></mat-icon> -->
                      {{additionalService.serviceName}}
                      <span class="detail-price ml-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span> </span>
                      <!-- <div class="description">{{additionalService.description}}</div> -->
                    </div>
                  </div>
                </div>
              </div>




            </div>

            <!--End Agent Delivery Service-->
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div
      *ngIf="getAdditionalServiceReservationCaseTypeCharge!=null&&getAdditionalServiceReservationCaseTypeCharge.length >0">


      <h2 class="mt-5">
        <div class="selected-class-title">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faDollarSign"></fa-icon>
          {{ 'AdditionalCharge' | translate }}
        </div>
      </h2>
      <ng-container
        *ngIf="vehicleReservationCaseDetailsModel!=null&&vehicleReservationCaseDetailsModel.lstAdditionalServiceReservationCase!=null">
        <div class="ml-4" *ngFor="let additionalService of getAdditionalServiceReservationCaseTypeCharge">

          <div class="row">
            <div class="col-md-1 col-2 slider text-right mt-1">

              <div class="custom-control custom-switch custom-switch-additional">
                <input type="checkbox" (change)="changeDisable(additionalService)"
                  [formControlName]="formControlPrefix+additionalService.additionalServiceID+'_toggle'"
                  class="custom-control-input" [id]="additionalService.additionalServiceID">
                <label class="custom-control-label" [for]="additionalService.additionalServiceID"></label>
              </div>


            </div>
            <div class="col-md-11 col-10 mb-2 mobile-margin pl-0">
              <div class=" ml-2 mr-3  ">
                <div class="detail-title d-flex">
                   <img class="icon-extra"
                      [src]="attachmentService.getImageLink(additionalService.predefinedAdditionalServiceID,attachmentScopesEnum.Setting, attachmentTypeEnum.AdditionalServicesIcon)" />
                    {{additionalService.serviceName}}

                  <!-- <mat-icon class="mr-1 detailsIcon" svgIcon="childSeats"></mat-icon> {{additionalService.serviceName}} -->
                  <span class="detail-price ml-3">{{additionalService.unitPrice | number}} {{currency}} <span *ngIf="additionalService.isPerDay"> / {{ 'Day' | translate }}</span></span>
                </div>
                <!-- <div class="description">{{additionalService.description}}  </div> -->
              </div>


            </div>
          </div>

        </div>
      </ng-container>

    </div>
  </mat-tab>


  <!--Policies-->
  <mat-tab label="{{ 'Policies' | translate }}">
    <ng-container *ngIf="tab.selectedIndex == 1">
      <policies [lstPolicyReservationCaseModel]="lstPolicyReservationCaseModel"></policies>
    </ng-container>

  </mat-tab>

  <!--Reviews-->
  <mat-tab label="{{ 'Reviews' | translate }}">
    <ng-container  *ngIf="tab.selectedIndex == 2">
      <view-reviews [vehicle]="vehicle"></view-reviews>
    </ng-container>

  </mat-tab>

  <!--Terms & Conditions-->
  <mat-tab label="{{ 'TermsAndConditions' | translate }}" (click)="loadTermsAndCondition()">
    <div class="tearmsAndCondition" [innerHTML]="TermsAndCondition">

    </div>
  </mat-tab>

</mat-tab-group>
<simple-notifications></simple-notifications>
